/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'per-night': {
    width: 24,
    height: 24,
    viewBox: '-8 -8 40 40',
    data: '<g _stroke="#000"><g><polygon pid="0" _fill="none" stroke-linejoin="round" stroke-miterlimit="10" points="16.091,6.09 19,5 16.091,3.908 15,1 13.909,3.908 11,5 13.909,6.09 15,9"/><polygon pid="1" _fill="none" stroke-linejoin="round" stroke-miterlimit="10" points="20.545,11.545 22,11 20.545,10.454 20,9 19.455,10.454 18,11 19.455,11.545 20,13"/><path pid="2" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M17 15.5c-5.72 0-9.798-5.537-8.126-10.994C4.238 4.574.5 8.348.5 13a8.501 8.501 0 0016.626 2.493c-.042.001-.083.007-.126.007z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/per-night.js